import Rectangle from "./Rectangle";
import Area from "./Area";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class FlatOval extends AbstractShape {
	static NAME = "flat-oval";

	constructor( width, radius ) {
		super();

		this.width = width;
		this.radius = radius;
	}

	get_name() {
		return FlatOval.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.get_width(), this.get_height() );
	}

	get_area() {
		const radius = this.get_radius().in_mm();
		const areaCircle = Math.PI * Math.pow( radius, 2 );
		const width = this.get_width().in_mm() - ( radius * 2 );
		const areaRectangle = width * this.get_height().in_mm();
		const area = areaCircle + areaRectangle;

		return new Area( area );
	}

	get_circumference() {
		const radius = this.get_radius().in_mm();
		const diameter = radius * 2;

		const width = this.get_width().in_mm();

		const perimeterRectangle = 2 * ( width - diameter );
		const perimeterCircle = Math.PI * diameter;
		const perimeter = perimeterRectangle + perimeterCircle;

		return new Length( perimeter );
	}

	get_radius() {
		return this.radius;
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.radius.multiply( 2 );
	}

	get_maximum_dimensions( maximum_rectangle )	{
		return {
			width: maximum_rectangle.get_longest_side(),
			radius: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width", "radius" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			radius: this.radius.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new FlatOval( new Length( primitives.width ), new Length( primitives.radius ) );
	}
}
